var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 38,
    height: 38,
    rx: 9.5,
    stroke: "#C1C6C6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5968 13.4034C25.5968 16.6927 22.9335 20.5164 19.5 20.5164C16.0664 20.5164 13.4032 16.6927 13.4032 13.4034C13.4032 10.0411 16.1376 7.30664 19.5 7.30664C22.8623 7.30664 25.5968 10.0411 25.5968 13.4034ZM19.4998 22.5486C20.7781 22.5486 21.9629 22.1746 23.0167 21.5558C26.7205 21.7987 29.6612 24.8816 29.6612 28.6454V30.4033L28.955 30.6299C28.8188 30.6726 25.558 31.6938 19.4998 31.6938C13.4416 31.6938 10.1809 30.6726 10.0447 30.6299L9.3385 30.4033V28.6454C9.3385 24.8816 12.2792 21.7987 15.983 21.5558C17.0367 22.1746 18.2215 22.5486 19.4998 22.5486Z",
    fill: "#2D93FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.9e57cb45accc63a8548a408a14e69a43.svg";
export { ForwardRef as ReactComponent };